// components/RequireAuth.tsx
import { Outlet } from 'react-router-dom'; // adapte le chemin
import useAuth from '../features/auth/useAuth';

const RequireAuth = () => {
  const { isLogged } = useAuth({});

  return isLogged ? <Outlet /> : null;
};

export default RequireAuth;
